import { render, staticRenderFns } from "./AppNavigationGroupItem.vue?vue&type=template&id=085392e9"
import script from "./AppNavigationGroupItem.vue?vue&type=script&lang=ts"
export * from "./AppNavigationGroupItem.vue?vue&type=script&lang=ts"
import style0 from "./AppNavigationGroupItem.vue?vue&type=style&index=0&id=085392e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListGroup,VListItemTitle})
